import { SortAltIcon } from 'primereact/icons/sortalt';
import { SortAmountDownIcon } from 'primereact/icons/sortamountdown';
import { SortAmountUpAltIcon } from 'primereact/icons/sortamountupalt';

import { cn } from '@shared/lib/cn';

export type SortOrder = 'asc' | 'desc' | null;

/** A click sorts A→Z, then Z→A, then back to unsorted, as a `BaseTable` column header does. */
const nextSortOrder = (sort: SortOrder): SortOrder =>
  sort === null ? 'asc' : sort === 'asc' ? 'desc' : null;

export interface BaseSortHeaderProps {
  label: string;
  sort: SortOrder;
  onChange: (sort: SortOrder) => void;
  disabled?: boolean;
  'aria-label': string;
}

/** Sortable heading outside a `BaseTable`, with the same icons as its column headers. */
export function BaseSortHeader({
  label,
  sort,
  onChange,
  disabled,
  'aria-label': ariaLabel,
}: BaseSortHeaderProps) {
  const Icon = sort === 'asc' ? SortAmountUpAltIcon : sort === 'desc' ? SortAmountDownIcon : SortAltIcon;
  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        'inline-flex items-center gap-1.5 font-semibold tracking-[0.09em]',
        !disabled && 'cursor-pointer',
        sort && 'text-accent',
      )}
      onClick={() => {
        onChange(nextSortOrder(sort));
      }}
    >
      {label}
      <Icon aria-hidden className="w-2.5" />
    </button>
  );
}
